import { render } from "./App.vue?vue&type=template&id=18d99a3e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=18d99a3e&lang=scss"
script.render = render

export default script